<template>
  <router-view></router-view>
</template>

<script>
// import { useRouter, useRoute } from 'vue-router'

export default {
  name: 'root-page',
  components: {

  },
  data() {
    return {
      campaign: this.$route.fullPath
    }
  },
  mounted() {
    console.log("mounted");
    console.log(this.campaign);
  },
  methods: {

  },
  setup() {
    // const router = useRouter()
    // const route = useRoute()
    // console.log(router);

    // router.push({
    //   name: 'video',
    //   query: {
    //     ...route.query,
    //   },
    // })
  }
}



</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
